import React from "react";

const IndividualFootprintDashboard = () => {
  return (
    <div
      style={{ padding: "40px", backgroundColor: "#fff" }}
      className="h-screen"
    >
      <h2 className="p-10 text-xl">
        This is INDIVIDUAL FOOTPRINT DASHBOARD PAGE
      </h2>
    </div>
  );
};

export default IndividualFootprintDashboard;
